import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxGalleryModule } from '@kolkov/ngx-gallery';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { SharedPipesModule } from '../../pipes/shared-pipes.module';
import { ScConfirmationDialogComponent } from './sc-confirmation-dialog/sc-confirmation-dialog.component';
import { ScErrorDialogComponent } from './sc-error-dialog/sc-error-dialog.component';
import { ScFileViewerDialogComponent } from './sc-file-viewer-dialog/sc-file-viewer-dialog.component';
import { ScFullscreenDialogComponent } from './sc-fullscreen-dialog/sc-fullscreen-dialog.component';
import { ScGenericDialogComponent } from './sc-generic-dialog/sc-generic-dialog.component';
import { ScGoogleMapsDialogComponent } from './sc-google-maps-dialog/sc-google-maps-dialog.component';
import { ScImagePreviewDialogComponent } from './sc-image-preview-dialog/sc-image-preview-dialog.component';
import { ScInfoDialogComponent } from './sc-info-dialog/sc-info-dialog.component';
import { ScSuccessDialogComponent } from './sc-success-dialog/sc-success-dialog.component';

const components = [
  ScGenericDialogComponent,
  ScConfirmationDialogComponent,
  ScInfoDialogComponent,
  ScErrorDialogComponent,
  ScFullscreenDialogComponent,
  ScImagePreviewDialogComponent,
  ScGoogleMapsDialogComponent,
  ScSuccessDialogComponent,
  ScFileViewerDialogComponent
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    AgmCoreModule,
    NgxGalleryModule,
    NgxJsonViewerModule,
    MatProgressSpinnerModule,
    NgxExtendedPdfViewerModule,
    SharedPipesModule
  ],
  exports: components,
  entryComponents: components,
  providers: []
})
export class ScDialogsModule {}
